import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../core/theme/theme';
import ClientsTab from '../features/admin/ClientsTab';

export default function ClientsPage() {
  const { t } = useTranslation();

  return (
    <Box>
      {/* Hero header with background image */}
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          mx: { xs: -2, sm: -3, md: -5 },
          mt: { xs: -2, sm: -3, md: -5 },
          mb: 3,
          px: { xs: 2, sm: 3, md: 5 },
          py: { xs: 3, sm: 4 },
          minHeight: 140,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          component="img"
          src="/images/clients-header.webp"
          alt=""
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 30%',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(20, 23, 28, 0.55)',
          }}
        />
        <Stack spacing={0.5} sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant="h2" sx={{ color: colors.white, fontWeight: 700 }}>
            {t('admin.clients.title')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
            {t('admin.clients.subtitle')}
          </Typography>
        </Stack>
      </Box>
      <ClientsTab />
    </Box>
  );
}
